import AlarmsTable from "./AlarmsTable";

export default AlarmsTable